import http from "../config/axios";


export async function get_User() {
    const url = `/user`;
    try {
        const response = await http
            .request({
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                url,
            });
        return response.data;
    } catch (error) {
        console.error("Error fetching deliverymans:", error);
        throw error;
    }
}